var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"iv-p-24 iv-text-center"},[_c('p',{staticClass:"iv-fs-16 iv-fc-65 iv-text-center"},[_vm._v("功能即将上线 敬请期待...")]),_c('img',{staticClass:"iv-m-t-8",staticStyle:{"height":"320px"},attrs:{"src":require("@/assets/images/index/no-points.png")}})])])
}]

export { render, staticRenderFns }